import { render, staticRenderFns } from "./SubscriptionDetails.vue?vue&type=template&id=b82c8e60"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports